import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {createProject} from "../../actions/projects";
import ProjectForm from "./ProjectForm";

const ProjectNew = props => {
  const { codes, onSubmit, onCancel } = props;
  return <Card title='Project Details' className={'edit-view'}>
    <ProjectForm codes={codes} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    null,
    (dispatch, props) => ({
      onSubmit: (project) => dispatch(createProject(project, (projectid) => props.history.push(`/projects/${projectid}`))),
      onCancel: () => props.history.goBack()
    })
  )
)(ProjectNew);



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectNew.js